import React, {useContext} from "react";
import "./Skills.scss";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import {Fade} from "react-reveal";
import codingPerson2 from "../../assets/lottie/codingPerson2";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import StyleContext from "../../contexts/StyleContext";

import usePortfolio from "../../hooks/usePortfolio";
export default function Skills() {
  const {isDark} = useContext(StyleContext);
  const {illustration, skillsSection} = usePortfolio();
  if (!skillsSection.display) {
    return null;
  }
  return (
    <div className={isDark ? "dark-mode main" : "main"} id="skills">
      <div className="skills-main-div">
        <Fade left duration={1000}>
          <div className="skills-image-div">
            {illustration.animated ? (
              <DisplayLottie animationData={codingPerson2} />
            ) : (
              <img
                alt="Man Working"
                src={require("../../assets/images/developerActivity.svg")}
              ></img>
            )}
          </div>
        </Fade>
        <Fade right duration={1000}>
          <div className="skills-text-div">
            <h1
              className={isDark ? "dark-mode skills-heading" : "skills-heading"}
            >
              {skillsSection.title}{" "}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle skills-text-subtitle"
                  : "subTitle skills-text-subtitle"
              }
            >
              {skillsSection.subTitle}
            </p>
            <SoftwareSkill skillList={skillsSection.softwareSkills} />
            <div>
              {skillsSection.skills.map((skills, i) => {
                return (
                  <p
                    key={i}
                    className={
                      isDark
                        ? "dark-mode subTitle skills-text"
                        : "subTitle skills-text"
                    }
                  >
                    {skills}
                  </p>
                );
              })}
            </div>
            <p
                className={
                  isDark
                      ? "dark-mode subTitle skills-text-subtitle"
                      : "subTitle skills-text-subtitle"
                }
            >
              {skillsSection.subTitle2}
            </p>
            <SoftwareSkill skillList={skillsSection.otherSkills} />
          </div>
        </Fade>
      </div>
    </div>
  );
}
